import { ReactElement, useState } from "react";
import style from "./index.module.scss";
import { Color } from "../../../styles/typescript/types/color";
import Typography from "@/src/views/components/Typography";

const Adornment = ({
  children,
  ...props
}: {
  children?: JSX.Element;
  id?: string;
  onClick?: () => void;
}): ReactElement => {
  const handleClick = () => {
    if (props.onClick) {
      props.onClick();
    }
  };
  return <span id={`${props.id}-adornment`} onClick={handleClick}>{children}</span>;
};

const TextFields = (props: {
  onChange?: (e: any) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  label?: string;
  type?: string;
  placeholder?: string;
  maxLength?: number;
  value?: string;
  helperText?: string;
  endAdornment?: JSX.Element;
  onEndAdornment?: () => void;
  endAdornmentCondition?: boolean;
  helperTextColor?: Color;
  condition?: "empty" | "true" | "false";
  id?: string;
}): ReactElement => {
  const [state, setState] = useState({
    focus: false,
  });
  const handleChange = (e: any) => {
    if (props.onChange) {
      props.onChange(e);
    }
  };

  const handleFocus = () => {
    setState({ ...state, focus: true });
    if (props.onFocus) {
      props.onFocus();
    }
  };

  const handleBlur = () => {
    setState({ ...state, focus: false });
    if (props.onBlur) {
      props.onBlur();
    }
  };

  const handleEndAdornment = () => {
    if (props.onEndAdornment) {
      props.onEndAdornment();
    }
  };

  return (
    <div>
      <Typography variant="subtitle-4-demibold" color="mine_shaft">
        {props.label}
      </Typography>
      <div
        className={`${style["box-input"]} 
        ${props?.condition === "true" && style["box-input--focus"]}
        ${props?.condition === "false" && style["box-input--error"]}
        ${
          props?.condition !== "empty" && state.focus
            ? style["box-input--focus"]
            : ""
        }`}
      >
        <input
          className={style.input}
          id={props?.id}
          type={props.type}
          onChange={(e: any) => handleChange(e)}
          onFocus={() => handleFocus()}
          onBlur={() => handleBlur()}
          placeholder={props.placeholder}
          maxLength={props.maxLength}
          value={props.value}
        />
        {props.endAdornmentCondition && (
          <Adornment id={props.id} onClick={handleEndAdornment}>
            {props.endAdornment}
          </Adornment>
        )}
      </div>

      <div className={style["helper-text"]}>
        <Typography variant="body-medium-3" color={props.helperTextColor}>
          {props.helperText}
        </Typography>
      </div>
    </div>
  );
};

TextFields.defaultProps = {
  label: "",
  type: "text",
  placeholder: "",
  maxLength: 30,
  value: "",
  helperText: "",
  endAdornment: <span />,
  endAdornmentCondition: false,
  helperTextColor: "white",
  condition: "empty",
};

export default TextFields;
